/* eslint-disable @typescript-eslint/no-explicit-any */
// src/app/interceptors/demo-mode.interceptor.ts
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { UserState } from '@troyai/auth/data-access';
import { FeatureFlagsService } from '@troyai/feature-flags';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { PII_ENDPOINTS_REPLACEMENT_CONFIG } from './pii-endpoints.config';

@Injectable()
export class PIIAnonymizerInterceptor implements HttpInterceptor {
  private featureFlagsService = inject(FeatureFlagsService);
  private store = inject(Store);

  userDetails$ = this.store.select(UserState.userDetails);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Sync read is intentional: requests fired before /me resolves see demo-mode=false and skip
    // wrapping. Anonymization also requires userDetails (below), which arrives with the same /me
    // response, so the unwrapped pre-/me window carries no anonymizable member data in practice.
    if (!this.featureFlagsService.isFeatureEnabled('demo-mode')) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      withLatestFrom(this.userDetails$),
      map(([event, userDetails]) => {
        if (!userDetails?.settings?.flags?.demo_mode) {
          return event;
        }

        // Check if the event is an HttpResponse and contains personal data
        const url = new URL(req.url);
        const replacementConfig = this.getReplacementConfig(url.pathname);

        if (event instanceof HttpResponse && replacementConfig) {
          console.log('Match:', replacementConfig.url, url.pathname);
          // Anonymize the personal data
          const modifiedBody = replacementConfig.replacer(event.body.data);

          // Replace the response body with the modified data
          return event.clone({
            body: {
              ...event.body,
              data: modifiedBody,
            },
          });
        }
        return event;
      })
    );
  }

  private getReplacementConfig(url: string) {
    return PII_ENDPOINTS_REPLACEMENT_CONFIG.find((item) => item.urlRegex.test(url));
  }
}
